import { walletClient } from "../clients/walletClient"
import type { WalletResponseDto } from "../types/wallet.types"

export const walletService = {
  getWalletByUserId: async (userId: string): Promise<WalletResponseDto> => {
    try {
      const wallet = await walletClient.getWalletByUserId(userId)
      return wallet
    } catch (error: any) {
      throw error
    }
  },
}

export default walletService
